import React, {useEffect} from 'react'
import PageLoad from '../page-load'
import {meGet} from '@api'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '@/state/auth'
import {shallow} from 'zustand/shallow'

const FetchingMe = () => {
  const navigate = useNavigate()
  const {logout, meReceived} = useAuth(
    state => ({
      logout: state.logout,
      meReceived: state.meReceived,
    }),
    shallow
  )
  useEffect(() => {
    meGet().then(response => {
      if (response.status === 200) {
        meReceived(response.data)
      } else {
        logout()
        navigate('/login')
      }
    })
  }, [])

  return <PageLoad />
}

export default FetchingMe
